import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const department = params.get("department") || "";
  const search = params.get("search") || "";
  const onSale = params.get("on_sale") === "true";

  useEffect(() => {
    api.get("/departments").then((r) => setDepartments(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (department) q.department = department;
    if (search) q.search = search;
    if (onSale) q.on_sale = true;
    api.get("/products", { params: q }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [department, search, onSale]);

  const selectDept = (d) => {
    const np = new URLSearchParams();
    if (d) np.set("department", d);
    setParams(np);
  };
  const selectSale = () => setParams(new URLSearchParams({ on_sale: "true" }));

  const title = onSale
    ? "Venta — Precios rebajados"
    : search ? `Resultados: "${search}"` : department || "Todos los productos";

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12" data-testid="shop-page">
      <div className="mb-10">
        <div className="label-caps text-[#C0A062] mb-2">Tienda</div>
        <h1 className="font-serif text-4xl md:text-5xl text-stone-900">{title}</h1>
      </div>

      {/* Department filters */}
      <div className="flex flex-wrap gap-3 mb-12 border-b border-stone-200 pb-6">
        <button onClick={() => selectDept("")} className={`px-5 py-2 text-sm transition-colors ${!department && !search && !onSale ? "bg-[#3F4E4F] text-white" : "border border-stone-300 text-stone-700 hover:bg-stone-100"}`} data-testid="filter-all">
          Todo
        </button>
        <button onClick={selectSale} className={`px-5 py-2 text-sm transition-colors ${onSale ? "bg-[#991B1B] text-white" : "border border-[#991B1B] text-[#991B1B] hover:bg-[#991B1B]/5"}`} data-testid="filter-venta">
          Venta
        </button>
        {departments.map((d) => (
          <button key={d} onClick={() => selectDept(d)} className={`px-5 py-2 text-sm transition-colors ${department === d ? "bg-[#3F4E4F] text-white" : "border border-stone-300 text-stone-700 hover:bg-stone-100"}`} data-testid={`filter-${d}`}>
            {d}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-stone-400 py-20 text-center">Cargando productos...</div>
      ) : products.length === 0 ? (
        <div className="text-stone-500 py-20 text-center" data-testid="no-products">
          {onSale ? "No hay productos en oferta por ahora." : "No se encontraron productos."}
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14" data-testid="products-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
